import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state:{
        contentList:{},
        userInfo:{},
        isAdmin:false,
        userName:'',
        currentTag:''
    },
    getters:{

    },
    mutations:{
    },
    actions:{

    }
})


// WEBPACK FOOTER //
// ./src/store/store.js